import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BillingV2Service, PlatformService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { Collection, CollectionLicenseEnum } from 'lingo2-models';
import { Observable } from 'rxjs';

export interface ICollectionLicensePriceOption {
  license: CollectionLicenseEnum;
  label: string;
  price_tier: number;
}

@Component({
  selector: 'app-collection-license-prices',
  templateUrl: './collection-license-prices.component.html',
  styleUrls: ['./collection-license-prices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionLicensePricesComponent extends ChangableComponent implements OnChanges {
  @Input()
  collection: Collection;

  public licensePriceOptions: ICollectionLicensePriceOption[] = [];

  constructor(
    private billingV2Service: BillingV2Service,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
  ) {
    super(cdr, platform);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.collection) {
      this.prepareCard();
    }
  }

  public getFormattedPrice(amount: number): Observable<string> {
    return this.billingV2Service.formatAmount$(amount);
  }

  private prepareCard() {
    const price_tiers = this.collection?.price_tiers || {};
    this.licensePriceOptions = Object.entries(price_tiers)
      .filter(([license, price_tier]) => +price_tier > 0)
      .map(([license, price_tier]) => ({
        license: +license,
        price_tier: +price_tier,
        label: 'collection-license-short.' + CollectionLicenseEnum[license],
      }));
    this.markForCheck();
  }

  public trackByFn(index) {
    return index;
  }
}
